import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type ShipmentProviderId = Branded<string, "ShipmentProviderId">;
const shipmentProviderIdPrefix = "shipment_provider__";
const {
    zodSchema: shipmentProviderIdZodSchema,
    factory: shipmentProviderIdFactory,
    assert: isShipmentProviderId,
} = genericId<ShipmentProviderId>(shipmentProviderIdPrefix, {
    regexMatch: /^(shipment_provider_|shipment_provider__\S+)$/,
});

export {
    isShipmentProviderId,
    shipmentProviderIdFactory,
    shipmentProviderIdPrefix,
    shipmentProviderIdZodSchema,
};
export type { ShipmentProviderId };
